<sbd-account-portal-frontend-send-message
  #composer
  [showTopBand]="false"
  [showInlineButtons]="false"
  [fullWidth]="true"
  [inDrawer]="true"
  [task]="data?.task"
  (cancelMessage)="closeDrawer()"></sbd-account-portal-frontend-send-message>
<cipx-action-bar [sticky]="true" [removeStickyOnMobile]="true" [justify]="'start'">
  <cipx-primary-button (buttonClick)="onSend()" icon="send">Send</cipx-primary-button>
  <cipx-cancel-button (buttonClick)="closeDrawer()">Cancel</cipx-cancel-button>
</cipx-action-bar>
